// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getRootCauseOfDelayReasons(projectId: string, filter: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/delay_rootcause${filter === 'days' ? '?delay=true' : ''}`);
}
